var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"display-1 font-weight-bold mx-1 mb-3"},[_vm._v("Marketing Tools")]),_c('v-card',[_c('v-card-text',[_vm._v(" Coming Soon ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }